<!-- <p>pasajero-confirmado works!</p> -->

<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link active" [routerLink]="['/admin/tours-confirmados']" >Confirmados</a>        
    </li>
    
    <li class="nav-item pe-2">
        <a class="nav-link" aria-current="page"  [routerLink]="['/admin/tours']" >Reservados</a>  
    </li>
    
</ul>
<div class="row">
    <div class="col-12 mt-4">
        <!-- <form action="" class="login">
            <div class="form-control p-0 position-relative">
                <input type="search" class="w-100 border-secondary" placeholder="Ingrese su busqueda por destino, mes, pasajero o DNI">
                <img src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon" alt="">
            </div>
        </form> -->
        
    </div>
    <!-- <div class="col-12 mt-4 d-flex">
        <div class="text-secondary rounded-pill border border-2 me-3 border-secondary btn-md btn-outline">
            Destino
        </div>
    </div> -->
</div>

<div *ngIf="idPasajerorecibido">
    <div class="d-flex align-items-baseline mt-5">
        <h2>{{pasajeroFicha.nombre_pasajero}}</h2>
    </div>
    <h4 class="title-bg mt-4" style="float: left;">Datos del pasajero</h4>
    <div class="label_bb">                   
        <div class="col-6 d-flex align-items-center" *ngIf="datosPasajero.bebe">
          <input type="radio" class="ps-2"  checked>
          <p class="mb-0 ps-2">Pasajero bebé</p>
        </div>                            
      </div> 
    <form action="" class="login mt-5">
        <div class="row">
            <div class="col-md-6 col-12">
                <div class="form-control">
                    <h5 class="mb-2">Nombre completo</h5>
                    <input type="text" name="nombre" disabled class="w-100" [(ngModel)]="pasajeroFicha.nombre"> 
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Teléfono</h5>
                    <input type="text" name="tel" disabled class="w-100" [(ngModel)]="pasajeroFicha.telefono"> 
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Correo Electrónico</h5>
                    <input type="email" name="email" disabled class="w-100" [(ngModel)]="pasajeroFicha.email"> 
                </div>
                <div class="form-control" *ngIf="!datosPasajero.bebe">
                    <h5 class="mb-2">Asiento</h5>
                    <input type="text" name="asiento" disabled class="w-100" [(ngModel)]="pasajeroFicha.asiento"> 
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Observaciones generales</h5>
                    <textarea type="text" name="obs" disabled class="w-100" placeholder="Escriba aqui si el pasajero posee alguna enfermedad o alergía alimenticia." [(ngModel)]="pasajeroFicha.observaciones"></textarea>
                </div>
                <div class="form-control">
                    <h5 class="mb-3" style="margin-top: 6rem;">En caso de emergencia comunicarse con</h5>
                    <h5 class="mb-2">Nombre completo</h5>
                    <input type="text" name="nombreEm" disabled class="w-100" [(ngModel)]="pasajeroFicha.nombreEmergencia"> 
                </div>
                <div class="form-control" style="margin-top: 12.5rem;">
                    <h5 class="mb-2">Teléfono</h5>
                    <input type="text" name="telEm" disabled class="w-100" [(ngModel)]="pasajeroFicha.telefonoEmergencia"> 
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="form-control">
                    <h5 class="mb-2">Tipo de Documento</h5>  
                    <!-- <select name="tipo-documento" class="documento w-100" id="" >
                      <option value="Seleccionar tipo" selected disabled>Seleccionar tipo</option>
                      <option value="DNI">DNI</option>
                      <option value="otro">Otro</option>
                    </select> --> 
                    <input type="text" name="tiodoc" disabled class="w-100" [(ngModel)]="pasajeroFicha.tipoDoc">  <!-- estatico, dado que solo se muestra el que existe en bd --> 
                </div>
                <div class="form-control">
                    <h5 class="mb-2">N° de Documento</h5>
                    <input type="number" id="number" disabled [(ngModel)]="pasajeroFicha.numerDoc" placeholder="Ingrese el número de documento" name="ndoc" class="w-100" max="8" min="0" maxlength="8" onKeyPress="if(this.value.length==8) return false;"> 
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Documento</h5>
                    <label for="adjuntar" >
                        <div class="border border-2 border-primary p-2 rounded-pill click-adjuntar" (click)=" descargarDoc()">
                            <img src="../assets/images/body/icons/adjuntar.svg" class="ps-3 rotate" alt="" >
                            <span style="cursor: pointer;"  class="iborrainputfile">Descargar</span>
                            
                        </div>
                    </label>
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Ficha médica</h5>
                    <label for="adjuntar" >
                        <div class="border border-2 border-primary p-2 rounded-pill click-adjuntar" (click)=" descargarFicha()" >
                            <img src="../assets/images/body/icons/adjuntar.svg" class="ps-3 rotate" alt="" >
                            <span style="cursor: pointer;" class="iborrainputfile">Descargar</span>
                            
                        </div>
                    </label>
                </div>
                <div class="form-control">  <!-- ! verificar -->
                    <h5 class="mb-2">Tipo de habitación</h5>
    
                    <div *ngIf="pasajeroHabitacion.id === 1; else noIndividual" class="col-6 d-flex align-items-center">
                        <input type="radio" class="ps-2" name="habitacionT1" value="Individual" checked> <p class="mb-0 ps-2">Individual</p>
                    </div>
                    <ng-template #noIndividual>
                        <div class="col-6 d-flex align-items-center">
                            <input type="radio" class="ps-2" name="habitacionT1" value="Individual" disabled> <p class="mb-0 ps-2">Individual</p>
                        </div>
                    </ng-template>
    
                    <div *ngIf="pasajeroHabitacion.id === 2; else noDoble" class="col-6 d-flex align-items-center">
                        <input type="radio" class="ps-2" name="habitacionT2"  value="Doble" checked> <p class="mb-0 ps-2">Doble</p>
                    </div>
                    <ng-template #noDoble>
                        <div class="col-6 d-flex align-items-center">
                            <input type="radio" class="ps-2" name="habitacionT2"  value="Doble" disabled> <p class="mb-0 ps-2">Doble</p>
                        </div>
                    </ng-template>
    
                    <div *ngIf="pasajeroHabitacion.id === 3; else noTriple"  class="col-6 d-flex align-items-center">
                        <input type="radio" class="ps-2" name="habitacionT3"  value="Triple" checked> <p class="mb-0 ps-2">Triple</p>
                    </div>
                    <ng-template #noTriple>
                        <div class="col-6 d-flex align-items-center">
                            <input type="radio" class="ps-2" name="habitacionT3"  value="Triple" disabled> <p class="mb-0 ps-2">Triple</p>
                        </div>
                    </ng-template>
    
                    <div *ngIf="pasajeroHabitacion.id === 4; else noCuadruple"  class="col-6 d-flex align-items-center">
                        <input type="radio" class="ps-2" name="habitacionT4"  value="Cuadruple" checked> <p class="mb-0 ps-2">Cuadruple</p>
                    </div>
                    <ng-template #noCuadruple>
                        <div class="col-6 d-flex align-items-center">
                            <input type="radio" class="ps-2" name="habitacionT4"  value="Cuadruple" disabled> <p class="mb-0 ps-2">Cuadruple</p>
                        </div>
                    </ng-template>
                </div>
                <div class="form-control" style="margin-top: 6rem; margin-bottom: 0.5rem;">
                    <h5 class="mb-2">Redes sociales</h5>
                </div>
                <div class="form-control d-flex align-items-center flex-row" style="margin-bottom: 2rem">
                    <img src="../assets/images/body/icons/twitter.svg" class="pe-3" alt="">
                    <input type="text" name="twt" disabled class="w-100" [(ngModel)]="pasajeroFicha.twitter"> 
                </div>
                <div class="form-control d-flex align-items-center flex-row" style="margin-bottom: 2rem">
                    <img src="../assets/images/body/icons/facebook.svg" class="pe-3" alt="">
                    <input type="text" name="face" disabled class="w-100" [(ngModel)]="pasajeroFicha.facebook"> 
                </div>
                <div class="form-control d-flex align-items-center flex-row" style="margin-bottom: 2rem">
                    <img src="../assets/images/body/icons/instagram.svg" class="pe-3" alt="">
                    <input type="text" name="insta" disabled class="w-100" [(ngModel)]="pasajeroFicha.instagram"> 
                </div>
            </div>
        </div>
    </form>
</div>




<div class="row">
</div>

<section>
    <div class="container" style="margin-top: 4rem;">
        <div class="row">
            <div class="col-12 text-center z-index--top">
                <a style="cursor: pointer;"  class="btn btn-lg rounded-pill btn-primary text-white text-center align-self-center me-3" (click)=" descargarPlanilla()">
                <img style="cursor: pointer;"  src="../assets/images/body/icons/descargar-comprobante.svg" class="pe-3" alt="" (click)=" descargarPlanilla()">  Descargar planilla</a>
            </div>
        </div>
    </div>
</section>


